import { Component, h } from 'preact'
import { BulkAction } from '../index'
import axios from 'axios'
import { getIdAndContentTypeFromTopics } from './utils'
import Icon from '../../assets'
import ButtonControl from '../../button-control'
import ListSelector from '../../list-selector/ListSelector'
import DropdownControl from '../../dropdown/DropdownControl'
import { Category, ParentCategory } from '../../category-selector/CategorySelector'
import MoveToModal from './modals/MoveToModal'
import GroupedList from '../../list-selector/GroupedList'

export const moveTo = (categories: ParentCategory[]) => ({
  Component: ({ numberOfSelectedTopics, performBulkAction } : { numberOfSelectedTopics: number, performBulkAction: (bulkAction: BulkAction) => void }) =>
    <MoveTo
      numberOfSelectedTopics={numberOfSelectedTopics}
      categories={categories}
      performBulkAction={performBulkAction}
    />
})

type Props = {
  numberOfSelectedTopics: number,
  categories: ParentCategory[],
  performBulkAction: (bulkAction: BulkAction) => void
}

type State = {
  category: any | null,
  isMoveToModalOpen: boolean
}

class MoveTo extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      category: null,
      isMoveToModalOpen: false
    }
  }

  onCategorySelect = (category: Category) => {
    this.setState({ category, isMoveToModalOpen: true })
  }

  onMoveTo = () => {
    const { performBulkAction } = this.props
    const { category } = this.state

    const bulkAction = {
      successMessage: `Topic(s) moved to '${category.categoryName}'`,
      onClick: async (selectedTopics: any) => axios.post(`/community/api/bulk/process?moderatorId=${window.inSidedData.user.userid}`, {
        'action': 'move',
        'topics': getIdAndContentTypeFromTopics(selectedTopics),
        'params': {
          categoryId: category.categoryId
        }
      })
    }

    performBulkAction(bulkAction)

    this.setState({ isMoveToModalOpen: false })
  }

  render ({ numberOfSelectedTopics, categories, performBulkAction }: Props, { category, isMoveToModalOpen }: State) {
    return <div>
      <DropdownControl
        align='adjust'
        trigger={
          <ButtonControl
            title={<div><Icon icon='move' width={16} height={16} />Move to</div>}
            size='medium'
            newStyle
            class='qa-move-to'
          />
        }
        items={[]}
      >
        {() => {
          return <ListSelector
            hasSearch
            placeholder='Search for category'
            items={
              categories.map(category => {
                return {
                  groupName: category.groupName,
                  items: !category.categories || category.categories.length === 0 ? [] : category.categories?.map(childCategory => ({
                    title: childCategory.categoryName,
                    value: childCategory.categoryId,
                    onClick: () => this.onCategorySelect(childCategory)
                  }))
                }
              }
            )}>
            {(filteredItems: any[]) =>
              <GroupedList
                items={filteredItems}
              />}
          </ListSelector>
        }}
      </DropdownControl>
      <MoveToModal
        numberOfSelectedTopics={numberOfSelectedTopics}
        categoryName={category?.categoryName}
        isOpen={isMoveToModalOpen}
        onMoveTo={this.onMoveTo}
        onClose={() => this.setState({ isMoveToModalOpen: false })}
      />
    </div>
  }
}
